import React from "react";
import { Box, Pagination, TablePagination, useTheme, useMediaQuery } from "@mui/material";

export default function AzottePagination({
  page,
  setPage,
  totalCount,
  rowsPerPage,
  onRowsPerPageChange,
  rowsPerPageOptions = [5, 10, 25],
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "stretch", sm: "center" }}
      gap={1}
      px={{ xs: 1, sm: 2 }}
      py={1}
    >
      <Pagination
        count={Math.ceil(totalCount / rowsPerPage)}
        page={page + 1}
        onChange={(_, newPage1Based) => setPage(newPage1Based - 1)}
        color="primary"
        size="small"
        showFirstButton={!isMobile}
        showLastButton={!isMobile}
        siblingCount={isMobile ? 0 : 1}
        boundaryCount={isMobile ? 1 : 1}
        sx={{
          display: "flex",
          justifyContent: { xs: "center", sm: "flex-start" },
        }}
      />
      <TablePagination
        component="div"
        rowsPerPageOptions={rowsPerPageOptions}
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(_, newPage) => setPage(newPage)}
        onRowsPerPageChange={onRowsPerPageChange}
        labelRowsPerPage={isMobile ? "Rows:" : "Rows per page:"}
        sx={{
          ".MuiTablePagination-toolbar": {
            minHeight: { xs: 40, sm: 52 },
            pl: { xs: 0, sm: 2 },
            pr: { xs: 0, sm: 1 },
            justifyContent: { xs: "center", sm: "flex-end" },
            flexWrap: "wrap",
          },
          ".MuiTablePagination-actions": {
            display: { xs: "none", sm: "flex" },
          },
          ".MuiTablePagination-displayedRows": {
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
          },
          ".MuiTablePagination-selectLabel": {
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
          },
        }}
      />
    </Box>
  );
}
